import Vue from 'vue'

export const TRADE_ROLE_LIST_KEY = 'tradeRoleList'
export const DEFAULT_TRADE_ROLE = 'SUPPLIER'
/** 参与菜单过滤的贸易角色；enterpriseRoleList 仅含其他角色时不做过滤 */
export const TRADE_ROLES = ['BUYER', 'SUPPLIER', 'FUNDER']
/** 角色过滤豁免的菜单编码：产品中心(My Unloq)/+ More Product 等固定入口对所有角色可见 */
export const ROLE_FILTER_EXEMPT_MENU_CODES = ['MORE10000']

export function getCachedTradeRoleList() {
  try {
    return JSON.parse(localStorage.getItem(TRADE_ROLE_LIST_KEY)) || []
  } catch (e) {
    return []
  }
}

function saveTradeRoleList(list) {
  try {
    localStorage.setItem(TRADE_ROLE_LIST_KEY, JSON.stringify(list))
  } catch (e) {}
  sessionStorage.setItem(TRADE_ROLE_LIST_KEY, JSON.stringify(list))
}

function saveTradeRole(role) {
  localStorage.setItem('tradeRole', role)
  sessionStorage.setItem('tradeRole', role)
  if (Vue.prototype.$setGlobalState) {
    Vue.prototype.$setGlobalState({ tradeRole: role })
  }
}

function pickDefaultRole(list) {
  if (!list.length) return ''
  if (list.length === 1) return list[0].dictParam
  const supplier = list.find(item => item.dictParam === DEFAULT_TRADE_ROLE)
  return (supplier || list[0]).dictParam
}

function parseRoleParam(role) {
  if (!role) return ''
  try {
    const parsed = JSON.parse(role)
    return (parsed && typeof parsed === 'object' ? parsed.dictParam : parsed) || ''
  } catch (e) {
    return role
  }
}

/**
 * 按菜单各层级的 enterpriseRoleList 过滤菜单树。
 * - 为空或缺失：不限角色，保留
 * - 仅含 BUYER/SUPPLIER/FUNDER 以外的角色：保留（不按当前贸易角色过滤）
 * - 含 BUYER/SUPPLIER/FUNDER：仅当当前角色命中其中贸易角色时保留
 * - 子菜单全部被过滤掉的父级菜单一并隐藏
 * - 命中 exemptMenuCodes 的菜单（如产品中心/My Unloq、+ More Product 固定入口）
 *   不参与角色过滤，且其子菜单被过滤光时入口本身仍保留
 * @param {Array} menus 接口返回的菜单树
 * @param {string} role 当前贸易角色 dictParam
 * @param {Array} [exemptMenuCodes] 豁免角色过滤的菜单编码（menuCode/mapCode）
 */
export function filterMenusByTradeRole(menus, role, exemptMenuCodes = []) {
  if (!Array.isArray(menus)) return []
  return menus.reduce((result, menu) => {
    const isExempt = exemptMenuCodes.includes(menu.menuCode || menu.mapCode)
    const roleList = Array.isArray(menu.enterpriseRoleList)
      ? menu.enterpriseRoleList.map(parseRoleParam).filter(Boolean)
      : []
    const tradeRoleList = roleList.filter(r => TRADE_ROLES.includes(r))
    if (!isExempt && tradeRoleList.length && !tradeRoleList.includes(role)) return result
    if (Array.isArray(menu.children) && menu.children.length) {
      const children = filterMenusByTradeRole(menu.children, role, exemptMenuCodes)
      if (!children.length && !isExempt) return result
      result.push({ ...menu, children })
    } else {
      result.push(menu)
    }
    return result
  }, [])
}

export async function fetchTradeRoleList(http) {
  const res = await http.get('/kj-kyc/productEnterprise/listFinancingEnterpriseRole')
  const list = (res && res.data && res.data.data.map(item=>JSON.parse(item))) || []
  saveTradeRoleList(list)
  if (window.vm) window.vm.$emit('tradeRoleListChange', list)
  return list
}

export function setOrgRole(http, role) {
  return http.get('/kj-web/sys/setOrgRole', { params: { enterpriseRole: role } })
}

/**
 * 在 setOrgId 之后调用：拉取当前企业的贸易角色列表，选中默认角色并同步给服务端
 * @param {import('axios').AxiosInstance} http
 */
export async function syncTradeRoleAfterSetOrg(http) {
  try {
    const list = await fetchTradeRoleList(http)
    const role = pickDefaultRole(list)
    if (!role) return
    saveTradeRole(role)
    await setOrgRole(http, role)
  } catch (e) {
    console.log(e)
  }
}
